import React, { useEffect } from 'react';
import { Text } from '@paypalcorp/pp-react';
import { getCoBrand } from '../utils';
import './style.css';
export const ApplePayConsent = ({ authEventHandler, countryCode, localizedContent, view }) => {
    useEffect(() => {
        authEventHandler({
            event: 'applePayConsentShown',
            data: {
                view: view || 'public_credential',
            },
        });
    }, [view]);
    const coBrand = getCoBrand(countryCode);
    const applePayTerms = React.createElement("a", { href: `/${coBrand}/webapps/mpp/ua/legalhub-full` }, localizedContent('terms'));
    const applePayPrivacyStatement = (React.createElement("a", { href: `/${coBrand}/webapps/mpp/ua/privacy-full` }, localizedContent('privacyStatement')));
    return (React.createElement(Text, { size: "md", className: "applePayConsent" }, localizedContent('applePayDisclosure', { terms: applePayTerms, privacyStatement: applePayPrivacyStatement })));
};
